export const mockMovies = [
  {
    id: 1,
    title: 'Inception',
    poster_path: 'https://image.tmdb.org/t/p/w500/9gk7adHYeDvHkCSEqAvQNLV5Uge.jpg',
    vote_average: 8.8,
    release_date: '2010-07-16',
    genres: ['Action', 'Sci-Fi', 'Thriller'],
    overview:
      'A thief who steals corporate secrets through dream-sharing technology is given the inverse task of planting an idea into the mind of a C.E.O.',
    similarity_score: 0.95,
  },
  {
    id: 2,
    title: 'The Matrix',
    poster_path: 'https://image.tmdb.org/t/p/w500/f89U3ADr1oiB1s9GkdPOEpXUk5H.jpg',
    vote_average: 8.7,
    release_date: '1999-03-31',
    genres: ['Action', 'Sci-Fi'],
    overview:
      'A computer hacker learns from mysterious rebels about the true nature of his reality and his role in the war against its controllers.',
    similarity_score: 0.92,
  },
  {
    id: 3,
    title: 'Interstellar',
    poster_path: 'https://image.tmdb.org/t/p/w500/gEU2QniE6E77NI6lCU6MxlNBvIx.jpg',
    vote_average: 8.6,
    release_date: '2014-11-07',
    genres: ['Adventure', 'Drama', 'Sci-Fi'],
    overview:
      "A team of explorers travel through a wormhole in space in an attempt to ensure humanity's survival.",
    similarity_score: 0.88,
  },
  {
    id: 4,
    title: 'The Dark Knight',
    poster_path: 'https://image.tmdb.org/t/p/w500/qJ2tW6WMUDux911r6m7haRef0WH.jpg',
    vote_average: 9.0,
    release_date: '2008-07-18',
    genres: ['Action', 'Crime', 'Drama'],
    overview:
      'When the menace known as the Joker wreaks havoc and chaos on the people of Gotham, Batman must accept one of the greatest psychological and physical tests of his ability to fight injustice.',
    similarity_score: 0.85,
  },
  {
    id: 5,
    title: 'Pulp Fiction',
    poster_path: 'https://image.tmdb.org/t/p/w500/fIE3lAGcZDV1G6XM5KmuWnNsPp1.jpg',
    vote_average: 8.9,
    release_date: '1994-09-10',
    genres: ['Crime', 'Drama'],
    overview:
      'The lives of two mob hitmen, a boxer, a gangster and his wife, and a pair of diner bandits intertwine in four tales of violence and redemption.',
    similarity_score: 0.82,
  },
];
